import {SRV as ApiServer} from "./server/SRV.js";
import MultiplexApi from "./server/MultiplexApi.ts";
import * as FwDatas from "./FwDatas.ts";
import * as i18n from "./i18n.ts";
import * as modal from "./util/modal.ts";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import "./server/decoders.js";

ApiServer.customcreditget = ApiServer.creditlistall.prepare(function(credits){
  var 
    currentFamilyID = parseInt(FwDatas.getLastFamilyId().substring(7)),
    activeCredits = credits
      .filter(credit=>credit.creditType==="FAMILYWALL_PREMIUM" || credit.creditType==="ORANGE_PREMIUM")
      .filter(credit=>credit.familyIds.length===0 ||credit.familyIds.indexOf(currentFamilyID)>-1)
      .filter(credit=>credit.startDate==undefined || new Date()>credit.startDate)
      .filter(credit=>credit.endDate==undefined || new Date()<credit.endDate),
    withoutTemp = activeCredits.filter(credit=>credit.paymentType!=="TWOCHECKOUT_TEMP")  
  
  return withoutTemp.length>0?withoutTemp:activeCredits;
})

amplify.subscribe('jserror',function(e){
  console.log(e);
  ApiServer.webjslog(window.location.pathname+" => "+e+"\n"+e.stack,()=>{},(e)=>console.log(e));
});
window.addEventListener('unhandledrejection', async event => {
  try{
    var e = event.reason;
    if(e.handledrejection) return;
    else e.handledrejection = true;

    modal.alert('fw2.defaultError');
    if(e instanceof Error){
      console.log(e);
      await ApiServer.webjslog(FizConfig.jsVersion + " "+window.location.pathname+" => "+e+"\n"+e.stack);
    }else{
      console.log(e);
      await ApiServer.webjslog(FizConfig.jsVersion + " "+window.location.pathname+" => "+e);
    }
  }catch(ee){
    //we do not want to loop in this if the call causes error
    console.log(ee);
  }
});

ApiServer.setDefaultErrorHandler(function(ex){
  if (ex.code === "http0"){
    throw ex
    
  }else if (ex.code === "httptimeout"){
    modal.alert('fw2.defaultError');
    ex.handledrejection = true;

  //means that the loadbalancer send us to a server in error
  //so we clean the cookie to make it do its job well
  }else if (ex.code === "http502"){
    cookieStore.delete({name:'JSESSIONID',domain:'familywall.com'})
    amplify.publish("sessionExpired",{fromApi:true});

  }else if (ex.code === "501" ||  ex.code === "507" ||  ex.code === "509"){
    // 501 no session ; 507 user deleted
    amplify.publish("sessionExpired",{fromApi:true});
  
  }else if (ex.code === "510"){
    // 510 no family
    libLocation.goTo("fw2_signup_family.php");
  
  }else if(ex.code==="506"){
    libLocation.refresh().then(()=>modal.alert('fw2.apierrors.506'));
   
  }else if(ex.code==="23"){
    //TODO put this in the next elseif by moving the key
    modal.alert('event.FizApiDistinctOccurenceIntersectException');
   
  }else if(ex.code==="7" && ex.subCode){
    modal.oops(i18n.get('fw2.apierrors.7'+ex.subCode, ex));
  }else if(ex.code==="610"||ex.code==="611"){
    //limit of number of items
    if(ex.type==='event'){
      import('./calendar/calendarclean.js').then(module=>{
        module.modalEventHardLimitReached()
      })

    }else{
      modal.oops(i18n.get('fw2.apierrors.610'+ex.type, ex));

    }
   
  }else if(ex.code==="601"){
    //limit of number of items
    import('./server/Medias.js').then(Medias=>Medias.quotaErrorHandler(ex.rightFlag))
   
  }else if(i18n.get('fw2.apierrors.'+ex.code) !== ('fw2.apierrors.'+ex.code)){
    modal.alert('fw2.apierrors.'+ex.code);
  
  }else{  
    ApiServer.webjslog(ex+"\t"+ex.stack,function(){},function(){})
    throw ex;
  }
});

var apiByMetaEnum = {
    "contact":["ctcput","ctcdelete"],
    "event":["evtcreate","evtdelete","evtupdate"],
    "task":["taskcreate","taskcreate2","taskdelete","taskmark","taskupdate","taskupdate2"],
    "tasklist":["taskcreatelist","taskdeletelist","taskrespondsuggested"],
    "place":["poicreate","poicreatesimple","poiupdate","poidelete"],
    "family":["accinvite","famsendinvite","adminremove"],
    "media":["wallpublishmultiplepics"]
}
Object.entries(apiByMetaEnum).forEach(function([metaIdType,apis]){
  var amplifyied = function(){
    try{
      amplify.publish("modified",metaIdType)
    }catch(e){
      console.log(e);
    }
  }
  apis.forEach(function(api){
    ApiServer[api] = ApiServer[api].prepare(amplifyied)
  });
});
ApiServer.metadelete = ApiServer.metadelete.prepare(function(){
  var 
    done = [],
    checkId = (id)=>{
      var type = id.substring(0,id.indexOf('/'));
      if(done.indexOf(type)===-1){
        done.push(type)
        amplify.publish("modified",type);
      }
    },
    ids = this.data.id;
  
  if(typeof ids==='string'){
    checkId(ids);
  }else if(Array.isArray(ids)){
    ids.forEach(checkId)
  }else{
    Object.values(ids).forEach(checkId)
  }
  
})
window.ApiServer = ApiServer;
window['M'] =  MultiplexApi;

export default ApiServer;